import { APICore } from "./apiCore";

const api = new APICore();

export interface LicencaLogoArquivo {
  id: number;
  nome: string;
  path: string;
  key: string;
  size: number;
}

export interface LicencaLogo {
  id: number;
  licenca_id: number;
  arquivo: LicencaLogoArquivo;
  created_at: string;
}

export interface GetLicencaLogoResponse {
  logo: LicencaLogo | null;
}

const getLicencaLogo = () => {
  return api.get<GetLicencaLogoResponse>("/licenca-logo");
};

const cadastrarLicencaLogo = (file: File) => {
  const formData = new FormData();
  formData.append("logo", file);
  return api.create<{ logo: LicencaLogo }>("/licenca-logo", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const removerLicencaLogo = () => {
  return api.delete("/licenca-logo");
};

export { getLicencaLogo, cadastrarLicencaLogo, removerLicencaLogo };
